import Dashboard  from './Dashboard';

export default Dashboard


// WEBPACK FOOTER //
// ./src/app/views/salesPerson/dashboard/index.js